import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Visa } from 'static/images/logos/payments/visa.svg';

function VisaComponent({ white }) {
  return (
    <Root white={white}>
      <Visa />
    </Root>
  );
}

export default VisaComponent;

const Root = styled.div`
  svg {
    height: 20px;
    #bottom-line,
    #top-line,
    #text {
      fill: ${({ theme }) => theme.colors.secondary.default};
    }

    ${({ white }) =>
      white &&
      `
      #bottom-line,
      #top-line,
      #text {
        fill: white;
        opacity: 0.5;
      }
    `}
  }
`;
